"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect, useState } from "react";
import { cleanupExpiredCache } from "@/lib/cache";
import { ligarPausaDasConsultas, refazerAoReconectar, retentarConsulta } from "@/lib/auth/pausaDasConsultas";

export default function QueryProvider({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        // With SSR, we usually want to set some default staleTime
                        // above 0 to avoid refetching immediately on the client
                        staleTime: 60 * 1000,
                        refetchOnWindowFocus: false,
                        // Faixa 28 D6: 403 `NETWORK_FORBIDDEN` nunca repete (`pausaDasConsultas.md`).
                        retry: retentarConsulta,
                        // Faixa 28 D6: o evento `online` não refaz consulta com a rede bloqueada.
                        refetchOnReconnect: refazerAoReconectar,
                    },
                },
            })
    );

    // Higiene do IndexedDB no boot do app (client-side; cleanupExpiredCache
    // é no-op em SSR). Best-effort, não bloqueia render.
    useEffect(() => {
        void cleanupExpiredCache();
    }, []);

    // Faixa 28 D6: com o bloqueio de rede aceso nenhuma consulta nova sai (intervalo, retentativa, foco).
    useEffect(() => ligarPausaDasConsultas(), []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
